<script setup lang="ts">
withDefaults(defineProps<{ color?: string }>(), { color: 'black' });
</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4.18031 10.9686C8.80936 8.8583 11.892 7.45659 13.4384 6.77585C17.8434 4.84656 18.7692 4.51392 19.3648 4.5C19.4975 4.5 19.7879 4.52785 19.9869 4.69494C20.1461 4.83418 20.1859 5.01366 20.2125 5.1529C20.239 5.29214 20.2655 5.583 20.239 5.80579C20.0002 8.44367 18.9697 14.8427 18.4404 17.7853C18.2149 19.0339 17.7785 19.4516 17.3554 19.4934C16.4296 19.5769 15.7279 18.8544 14.8419 18.2433C13.4399 17.2856 12.66 16.6884 11.2964 15.7446C9.72191 14.6616 10.7406 14.0644 11.6399 13.0928C11.8772 12.8438 15.9387 8.95577 16.0183 8.60921C16.0316 8.56744 16.0316 8.40036 15.9387 8.31836C15.8458 8.23481 15.7131 8.26265 15.6085 8.2905C15.4625 8.31835 13.2409 9.87323 8.9155 12.9412C8.28012 13.3992 7.71253 13.622 7.19656 13.608C6.62751 13.5941 5.54249 13.2754 4.72283 12.9969C3.73068 12.6643 2.93754 12.4833 3.00388 11.9C3.04368 11.5952 3.44025 11.2889 4.18178 10.9702L4.18031 10.9686Z"
          :fill="color" />
  </svg>

</template>

<style scoped lang="scss">

</style>
